import snackbarReducer from '@/states/snackbar.slice'
import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import axiomReportReducer from './states/axiomReport.slice'
import benchMarkReducer from './states/benchmark.slice'
import candidateScreenReducer from './states/candidateScreen.slice'
import optimizationConstraintReducer from './states/optimizationConstraint.slice'
import portfolioOptimizationReducer from './states/portfolioOptmization.slice'
import reportReducer from './states/report.slice'
import scenarioBuilderReducer from './states/scenarioBuilder.slice'
import verticallySplitLayoutReducer from './states/verticallySplitLayout.slice'
const persistConfig = {
  key: 'root',
  storage,
}

const rootReducer = combineReducers({
  report: reportReducer,
  benchmark: benchMarkReducer,
  axiomReport: axiomReportReducer,
  verticallySplitLayout: verticallySplitLayoutReducer,
  scenarioBuilder: scenarioBuilderReducer,
  portfolioOptimization: portfolioOptimizationReducer,
  candidateScreen: candidateScreenReducer,
  optimizationConstraint: optimizationConstraintReducer,
  snackbar: snackbarReducer,
})
const persistedReducer = persistReducer(persistConfig, rootReducer)

const persistedStore = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: process.env.NODE_ENV === 'production',
    }),
})

export type RootState = ReturnType<typeof persistedStore.getState>

export type AppDispatch = typeof persistedStore.dispatch

const persistor = persistStore(persistedStore)

export { persistedStore, persistor }
